import React, { useState } from "react";
import logo from "../assets/img/logo.svg";
import prev_arrow from "../assets/img/prev_arrow.svg";
import next_arrow from "../assets/img/next_arrow.svg";

const Step3 = ({ setStep, setFormdata, formData, setStep3Status }) => {
  const [occupationError, setOccupationError] = useState(false); // Error state for occupation

  // Handle Next button click
  const handleNext = () => {
    if (!formData?.occupation) {
      setOccupationError(true); // Show error if occupation is empty
    } else {
      setStep(4); // Proceed to the next step if occupation is valid
      setStep3Status(true); // Mark step 3 as completed
    }
  };

  return (
    <>
      <div class="top_logo_block">
        <div class="logo">
          <a href="">
            <img src={logo} alt="" />
          </a>
        </div>
      </div>

      <div class="step_body">
        <div class="step_form">
          <div class="form_block box_width_md_one">
            <h1>What's your profession?</h1>
            <div class="input_fields">
              <input
                type="text"
                placeholder="Tell me what you do"
                value={formData?.occupation || ""}
                onChange={(e) => {
                  setFormdata((prevState) => ({
                    ...prevState,
                    occupation: e.target.value, // Update the occupation field
                  }));
                  setOccupationError(false); // Clear error on input change
                }}
              />
              {occupationError && (
                <p style={{ color: "red" }}>Profession is required.</p>
              )}
            </div>
          </div>

          <div class="btn_block">
            <a onClick={() => setStep(2)}>
              <img src={prev_arrow} alt="" /> <span>Prev</span>
            </a>
            <a onClick={handleNext} class="nxt_btn">
              <span>Next</span> <img src={next_arrow} alt="" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Step3;